import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {
  Checkbox,
  CheckboxChangeEvent,
  CheckboxModule,
} from 'primeng/checkbox';

@Component({
  selector: 'ls-checkbox-atom',
  standalone: true,
  imports: [CheckboxModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxAtomComponent),
      multi: true,
    },
  ],
  templateUrl: './checkbox-atom.component.html',
  styleUrl: './checkbox-atom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxAtomComponent implements OnInit, ControlValueAccessor {
  @Input() checkboxId?: string;
  @Input() inputId?: string;
  @Input() binary = true;
  @Input() disabled = false;
  @Input() readonly = false;
  checked = false;

  @Output() change = new EventEmitter<boolean>();
  @ViewChild('checkbox') checkbox!: Checkbox;

  isDisabled = false;
  onChange = (_: any) => {};
  onTouch = () => {};

  ngOnInit(): void {}

  constructor(public cd: ChangeDetectorRef) {}

  writeValue(value: any): void {
    if (value !== undefined && value !== null) {
      this.checked = value;
      this.cd.markForCheck();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cd.markForCheck();
  }

  handleChange(event: CheckboxChangeEvent) {
    this.checked = event.checked;
    this.onTouch();
    this.onChange(this.checked);
    this.change.emit(event.checked);
  }
}
